import { createSlice } from '@reduxjs/toolkit';
import designListSlice from '../../redux/slices/designListSlice';
import { SELECT_TABLE_COLUMNS } from '../SelectTable/constants';

const selectTableSlice = createSlice({
	name: 'selectTable',
	slice: 'selectTable',
	initialState: {
		order: 'asc',
		orderBy: 'rank',
		actPage: 0,
		itemsPerPage: 10,
		optionalColumns: [],
		selectedOptionalColumns: [],
		columns: SELECT_TABLE_COLUMNS
	},
	reducers: {
		changeOrder(state, action) {
			state.order = action.payload.order;
			state.orderBy = action.payload.orderBy;
		},
		setPage(state, action) {
			state.actPage = action.payload;
		},
		setItemsPerPage(state, action) {
			state.itemsPerPage = action.payload;
		},
		setOptionalColumns(state, action) {
			state.optionalColumns = action.payload;
		},
		setAllColumns(state, action) {
			state.columns = action.payload.columns;
			state.selectedOptionalColumns = action.payload.selectedOptionalColumns;
		}
	},
	extraReducers: {
		[designListSlice.actions.setFetchDesignListData](state, action) {
			if (action.payload) {
				state.order = 'asc';
				state.orderBy = 'rank';
				state.actPage = 0;
				state.itemsPerPage = 10;
			}
		},
		[designListSlice.actions.filterItems](state, action) {
			state.actPage = 0;
		}
	}
});

export default selectTableSlice;
